/* unplugin-vue-components disabled */import script from "./member-rights.vue?vue&type=script&setup=true&lang=ts"
export * from "./member-rights.vue?vue&type=script&setup=true&lang=ts"

import "./member-rights.vue?vue&type=style&index=0&id=1d4e0157&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4e0157"]])

export default __exports__